import { useEffect } from "react";

export default function AntiCopy() {
  useEffect(() => {
    // Block right-click context menu (allow in form fields)
    const handleContextMenu = (e) => {
      const tag = e.target?.tagName?.toLowerCase();
      const isEditable = tag === "input" || tag === "textarea" || e.target?.isContentEditable;
      if (isEditable) return; // allow context menu in form fields
      e.preventDefault();
      return false;
    };

    // Block keyboard shortcuts for dev tools and source view
    const handleKeyDown = (e) => {
      // F12
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I (DevTools), Ctrl+Shift+J (Console), Ctrl+Shift+C (Inspect)
      if (e.ctrlKey && e.shiftKey && ["I", "i", "J", "j", "C", "c"].includes(e.key)) {
        e.preventDefault();
        return false;
      }
      // Ctrl+U (View Source)
      if (e.ctrlKey && (e.key === "u" || e.key === "U")) {
        e.preventDefault();
        return false;
      }
      // Ctrl+S (Save Page)
      if (e.ctrlKey && (e.key === "s" || e.key === "S")) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection via CSS
    const style = document.createElement("style");
    style.id = "anti-copy-styles";
    style.textContent = `
      body {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      input, textarea, [contenteditable="true"] {
        -webkit-user-select: text !important;
        -moz-user-select: text !important;
        -ms-user-select: text !important;
        user-select: text !important;
      }
    `;
    document.head.appendChild(style);

    // Block copy/cut (allow in form fields and contenteditable)
    const handleCopy = (e) => {
      const tag = e.target?.tagName?.toLowerCase();
      const isEditable = tag === "input" || tag === "textarea" || e.target?.isContentEditable;
      if (isEditable) return;
      e.preventDefault();
      return false;
    };

    // DevTools detection (debugger statement approach)
    let devtoolsCheckInterval;
    const checkDevTools = () => {
      const threshold = 160;
      const widthDiff = window.outerWidth - window.innerWidth;
      const heightDiff = window.outerHeight - window.innerHeight;
      if (widthDiff > threshold || heightDiff > threshold) {
        document.title = "Property Radar — Accesso non autorizzato";
      } else {
        document.title = "Property Radar — SIACASA Hub";
      }
    };
    devtoolsCheckInterval = setInterval(checkDevTools, 2000);

    // Block drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("copy", handleCopy);
    document.addEventListener("cut", handleCopy);
    document.addEventListener("dragstart", handleDragStart);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("cut", handleCopy);
      document.removeEventListener("dragstart", handleDragStart);
      clearInterval(devtoolsCheckInterval);
      const styleEl = document.getElementById("anti-copy-styles");
      if (styleEl) styleEl.remove();
    };
  }, []);

  return null;
}
